<img src="../../../../assets/images/affiliate-modal.webp" alt="" />
<button (click)="changeAffiliateModal()" [disabled]="loading">确认</button>
